import React, { useEffect, useState } from "react";
import { Clipboard } from "react-bootstrap-icons";
import { Mixpanel } from "../../Mixpanel";
import Toast from "../assetLibComponents/shared/Toast";
import { FaReact } from "react-icons/fa";
import { PiAngularLogo } from "react-icons/pi";
import { TbBrandNextjs } from "react-icons/tb";
import { BiLogoWordpress } from "react-icons/bi";
import { TbBrandJavascript } from "react-icons/tb";
import { sendDeveloperMail } from "../../redux/actions/chatAiActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";


const ChatDeveloper = (props) => {
  const [embeddCode, setEmbeddCode] = useState("");
  const [emails, setEmails] = useState("");
  const dispatch = useDispatch();
  const designData = useSelector((state) => state.chatAi.designData);
  const storedUserData = JSON.parse(localStorage.getItem("userData"));
  useEffect(() => {
    let tempUrl = `${window.location.href}`;
    const stagCode = `<script src='https://web-stag.askzoi.com/zap-chatbot/chatscript.js?version=2.13' data-client-id="${storedUserData?.data?.client_id}"></script>`;
    const devCode = `<script src='https://web.askzoi.com/zap-chatbot/chatscript.js?version=2.13' data-client-id="${storedUserData?.data?.client_id}"></script>`;
    const prodCode = `<script src='https://script.askzoi.ai/chatscript.js?version=2.13' data-client-id="${storedUserData?.data?.client_id}"></script>`;

    if (tempUrl.search("localhost") > 0) {
      setEmbeddCode(stagCode);
    } else if (tempUrl.search("dev.askzoi.com") > 0) {
      setEmbeddCode(devCode);
    } else if (tempUrl.search("sia.technochimes.com") > 0) {
      setEmbeddCode(stagCode);
    } else if (tempUrl.search("sia.salespanda.com") > 0) {
      setEmbeddCode(prodCode);
    } else {
      setEmbeddCode(devCode);
    }
  }, []);

  const handleClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Toast(`Copied to Clipboard`, "S");
    Mixpanel.track("Copied the embed code");
  };

  const openLinkInNewTab = (linkUrl) => {
    // Check if the URL has a protocol
    linkUrl?.length > 0 && window.open(linkUrl, "_blank");
  };

  function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

function validateEmails(emailArray) {
  for (const email of emailArray) {
      if (!validateEmail(email)) {
          return false; // Return false if any email fails validation
      }
  }
  return true; // If all emails pass validation, return true
}

  const handleSubmit = () =>{
    if(emails !== ""){
      const value = emails.split(' ');
      const validatedEmails = validateEmails(value);
      if(validatedEmails){
        dispatch(sendDeveloperMail(props.authToken, value,storedUserData?.data?.client_id))
        setEmails("")
      }else{
        Toast(`Please enter Valid Email-id`, "E");
      }
    }else{
      Toast(`Please enter an Email-id to proceed`, "E");
    }
  }

  return (
    <>
      <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <div className="text-base font-semibold leading-6 text-gray-900">
              Embed Code
            </div>
            <p>
              Please embed the script generated below according to your
              specifications into your website.
            </p>
            <div className="mt-2">
              <div className="w-full flex max-sm:flex-col bg-gray-200 rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
              <Clipboard
                  className="ml-auto cursor-pointer sm:hidden"
                  onClick={()=>handleClipboard(embeddCode)}
                />
                <div
                  style={{ wordWrap: "break-word" }}
                  className="block resize-none text-orange-600 w-full border-0 p-0 bg-gray-200 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                >
                  {embeddCode}
                </div>
                <Clipboard
                  className="max-sm:hidden ml-auto cursor-pointer"
                  onClick={()=>handleClipboard(embeddCode)}
                />
              </div>
            </div>
           {designData?.type === "AMA" && <> 
            <p className="mt-3">
              Please embed the div generated below according to your
              specifications into your website.
            </p>
            <div className="mt-2">
              <div className="w-full flex bg-gray-200 rounded-md px-3 pb-1.5 mt-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                <div
                  style={{ wordWrap: "break-word" }}
                  className="block resize-none text-orange-600 w-full border-0 p-0 bg-gray-200 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                >
                  {`<div id="rootChat" className="amaBarClass"></div>`}
                </div>
                <Clipboard
                  className="ml-auto cursor-pointer"
                  onClick={()=>handleClipboard(`<div id="rootChat" className="amaBarClass"></div>`)}
                />
              </div>
            </div>
            </>}
          </div>
        </div>
      </div>
      <div className="bg-white mt-4 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <div className="text-base font-semibold leading-6 text-gray-900">
              Not a developer ?
            </div>
            <p>Send instructions to your developers.</p>
            <div className="mt-2">
              <div className="flex flex-col">
                <div className="py-1 px-2 mr-2 font-semibold">E-mails</div>
                <input
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                  type="text"
                  //ref={nameRef}
                  autoComplete="off"
                  placeholder="Space separated e-mails"
                  value={emails}
                  onChange={(e) => setEmails(e.target.value)}
                />
                <div
                  onClick={handleSubmit}
                  className="cursor-pointer mr-auto flex bg-[#49BCD2] text-white py-1 px-2 rounded-md my-6 font-[700]"
                >
                  Submit
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white mt-4 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <div className="text-base font-semibold leading-6 text-gray-900">
              Platform instructions
            </div>
            {/* <p>
            Please embed the script generated below according to your
            specifications into your website.
          </p> */}
            <div className="mt-2">
              <div className="flex">
                <div
                  onClick={() =>
                    openLinkInNewTab("https://kb.askzoi.ai/en/article/react")
                  }
                  className="py-1 px-2 mr-2 font-semibold border cursor-pointer border-gray-400 rounded-md flex hover:bg-[#49BCD2] hover:text-white"
                >
                  <span className="my-auto mr-1">
                    <FaReact />
                  </span>
                  React
                </div>
                {/* <div className="py-1 px-2 mr-2 font-semibold border border-gray-400 rounded-md flex"><span className="my-auto mr-1"><TbBrandNextjs/></span>Next</div> */}
                <div
                  onClick={() =>
                    openLinkInNewTab("https://kb.askzoi.ai/en/article/angular")
                  }
                  className="py-1 px-2 mr-2 font-semibold border cursor-pointer border-gray-400 rounded-md flex hover:bg-[#49BCD2] hover:text-white"
                >
                  <span className="my-auto mr-1">
                    <PiAngularLogo />
                  </span>
                  Angular
                </div>
                {/* <div className="py-1 px-2 mr-2 font-semibold border border-gray-400 rounded-md flex"><span className="my-auto mr-1"><BiLogoWordpress/></span>Wordpress</div> */}
                <div
                  onClick={() =>
                    openLinkInNewTab(
                      "https://kb.askzoi.ai/en/article/wordpress"
                    )
                  }
                  className="py-1 px-2 mr-2 font-semibold border cursor-pointer border-gray-400 rounded-md flex hover:bg-[#49BCD2] hover:text-white"
                >
                  <span className="my-auto mr-1">
                    <BiLogoWordpress />
                  </span>
                  Wordpress
                </div>
                {/* <div className="py-1 px-2 mr-2 font-semibold border border-gray-400 rounded-md flex"><span className="my-auto mr-1"><TbBrandJavascript/></span>Other Javascript apps</div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatDeveloper;
